import prefix from './../../prefix'
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
//stateBase可用来重置;
export let stateBase = {
  member:{//来自getUserInfoFromDB
    a:1,
    b:2,
    // imgUrl:"",
    // email:"",
    // mobile:"",
    // realName:"",
    corpName:"",
    // province:"",
    // city:"",
    // district:"",
    // postcode:"",
  },
  memberInfo:{//来自getUserInfoFromDB
    c:3,
    d:4,
  },
  secret:{
    isVerify:"",//是否校验了
    ps:"",
  },
  /*其他所有的*/
  other:{
    isGoOverdue:false,
  }
};

export default {
  namespaced: true,
  state:JSON.parse(JSON.stringify(stateBase)),
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/my/index.js